module.exports = __webpack_public_path__ + "img/pic-icon.608aab10.png";